import { cubicBezier } from "framer-motion";

export const animateVariants = {
	initial: "hidden",
	animate: "show",
	exit: "hidden",
};

export const fade = {
	variants: {
		hidden: { opacity: 0 },
		show: { opacity: 1, transition: { duration: 0.3, ease: "easeOut" } },
	},
};

export const fadeUp = {
	variants: {
		hidden: {
			opacity: 0,
			y: 10,
		},
		show: {
			opacity: 1,
			y: 0,
			transition: { duration: 0.6, ease: "easeOut" },
		},
	},
};

export const slideFade = {
	variants: {
		hidden: {
			opacity: 0,
			x: 0,
		},
		show: {
			opacity: 1,
			x: -200,
			transition: {
				x: {
					type: "tween",
					duration: 0.45,
					ease: [0.3, 0, 0.3, 1],
				},
			},
		},
		exit: {
			opacity: 0,
			x: -400,
			transition: {
				x: {
					type: "tween",
					duration: 0.3,
					ease: [1, 0.3, 0, 0.3],
				},
			},
		},
	},
};

export const slideLeft = {
	variants: {
		hidden: {
			x: 30,
		},
		show: {
			x: 0,
			transition: {
				duration: 2,
				ease: cubicBezier(0, 0, 0.25, 1),
			},
		},
	},
};

export const slideRight = {
	variants: {
		hidden: {
			x: -30,
		},
		show: {
			x: 0,
			transition: {
				duration: 2,
				ease: cubicBezier(0, 0, 0.25, 1),
			},
		},
	},
};

export const line = {
	variants: {
		hidden: {
			opacity: 0,
			width: 0,
		},
		show: {
			opacity: 1,
			width: "100%",
			transition: {
				opacity: { duration: 0.6 },
				width: { duration: 2, ease: [0.65, 0, 0.35, 1] },
			},
		},
	},
};

export const staggerChildren = {
	initial: "hidden",
	animate: "show",
	exit: "hidden",
	variants: {
		hidden: { opacity: 0 },
		show: {
			opacity: 1,
			transition: {
				when: "beforeChildren",
				staggerChildren: 0.15,
			},
		},
	},
};
